module.exports = __webpack_public_path__ + "static/kudo-interpreter-badge-73b579688dd23a17524c9d92961903a9.png";